let giftInProgress = false;

async function updateFreeGift(handle) {
  if (giftInProgress) return;
  giftInProgress = true;  

  try {
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) return;
    const cart = await cartResponse.json();
    const cartTotal = cart.items_subtotal_price;

    const productResponse = await fetch(`/products/${handle}.js`);
    if (!productResponse.ok) return;
    const product = await productResponse.json();
    const variantId = product.variants[0].id;

    const giftItem = cart.items.find(item => item.variant_id === variantId);

    if (cartTotal > window.theme.free_gift_threshold && !giftItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    } else if (cartTotal <= window.theme.free_gift_threshold && giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 })
      });
    }
  } catch (error) {
    console.error(error);
  } finally {
    giftInProgress = false;
    if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.jsAjaxCart) {
      window.cartUpdateSilent = true;
      Shopify.theme.jsAjaxCart.updateView();
    }
  }
}

function debounce(fn, timeout = 300) {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), timeout);
  };
}

const debouncedUpdateFreeGift = debounce((handle) => updateFreeGift(handle), 1000);

document.addEventListener('cartTotalUpdated', function() {
  debouncedUpdateFreeGift(window.theme.free_gift_handle);
});

updateFreeGift(window.theme.free_gift_handle);